import React, {Component} from 'react';
import LeadRow from "./LeadRow";
import moment from "moment";

export class FilterableLeadRow extends Component {
    matchesFilters() {
        return this.matchesTextFilter() && this.matchesStatusFilter() && this.matchesDateFilter();
    }

    matchesTextFilter() {
        if (this.props.filterValues.text !== '') {
            return this.matchesTextFilterByName() || this.matchesTextFilterByMessage();
        } else {
            return true;
        }
    }

    matchesTextFilterByName() {
        const searchString = this.props.filterValues.text.toLowerCase();
        const searchInFirstName = this.props.lead.firstName.toLowerCase().includes(searchString);
        const searchInLastName = this.props.lead.lastName.toLowerCase().includes(searchString);
        const completeName = this.props.lead.firstName.toLowerCase() + ' ' + this.props.lead.lastName.toLowerCase();
        const searchInCompleteName = completeName.includes(searchString);
        return searchInFirstName || searchInLastName || searchInCompleteName;
    }

    matchesTextFilterByMessage() {
        const searchString = this.props.filterValues.text.toLowerCase();
        const searchInMessage = this.props.lead.message.toLowerCase().includes(searchString);
        return searchInMessage;
    }

    matchesStatusFilter() {
        if (this.props.filterValues.status !== '') {
            return this.props.filterValues.status.toLowerCase() === this.props.lead.sellingState.toLowerCase();
        } else {
            return true;
        }
    }

    matchesDateFilter() {
        if (this.props.filterValues.fromDate && this.props.filterValues.toDate) {
            const dateOfLead = moment(this.props.lead.submittedOnFormatted);
            const fromDate = moment(this.props.filterValues.fromDate);
            const toDate = moment(this.props.filterValues.toDate);
            return fromDate.startOf('day') <= dateOfLead && dateOfLead <= toDate.startOf('day');
        } else {
            return true;
        }
    }

    render() {
        if (this.matchesFilters()) {
            return <LeadRow {...this.props.lead} crmFrontPath={this.props.crmFrontPath}
                            onStateChange={this.props.onStateChange}/>;
        } else {
            return null;
        }
    }
}